export const MemberApi = {

  LOGIN : '/login',                                               // 로그인		POST	/login
  LOGIN_SNS : '/login/sns',                                       // 간편로그인		POST	/login/sns
  AUTHENTICATE : '/authenticate',                                 // 인증토큰발급		POST	/authenticate
  FIND_ID : '/find/id',                                           // ID찾기		POST	/find/id
  SAVE_ID : '/save/id',                                           // ID설정   POST  /save/id
  FIND_PWD : '/find/pw',                                          // PW찾기		POST	/find/pw
  UPDATE_PWD : '/update/pw',                                      // 비밀번호변경		POST	/update/pw
  UPDATE_PWD2 : '/update/pw2',                                     // 비밀번호변경		POST	/update/pw2
  UPDATE_NICKNAME : '/member/nickname/update',                     // 닉네임변경   POST    /member/nickname/update
  UPDATE_USER_INFO : '/member/info/update',                       // 회원정보변경   POST    /member/info/update
  JOIN : '/join',                                                 // 회원가입		POST	/join
  GET_MEMBER_INFO : '/member/info',                               // 회원정보조회	O	GET	/member/info
  MEMBER_RETIRE : '/member/retire',                               // 회원탈퇴	O	POST	/member/retire
  MEMBER_AGREE : '/member/agree',                                 // 회원동의		POST	/member/agree
  MEMBER_CASH_RECEIPT : '/member/cashReceipt',                   // 현금영수증정보조회	O	GET	/member/cashRecipht/{memberKey}
  UPDATE_MEMBER_CASH_RECEIPT : '/member/cashReceipt/update',      // 현금영수증정보변경	O	POST	/member/cashRecipht/update
  GET_MEMBER_RANK : '/member/rank',                                // 회원등급정보   GET   /member/rank
  NICKNAME_CHECK : '/member/nickname/check',                      // 닉네임 중복확인    POST    /member/nickname/check
  ID_CHECK : '/id/check',                                         // 아이디 중복확인    POST    /id/check
  // 기존회원찾기

  REGISTER_CI : '/register/ci',                                   // 개인인증등록
  RESTORE_DORMANT : '/member/restore/dormant',               	    // 휴면회원복구
  CHECK_NICKNAME : '/member/nickname/check',                       //별칭중복확인
  UPDATE_MEMBER_INFO : '/member/info/update',                       //회원정보 수정

  UPDATE_PRIVACY : "/member/privacy/update",                       // 회원정보 업데이트
  GET_RESOURCE : "/member/resource/get",                            // 회원자원조회
  RETIRE_AND_REFUND: "/member/retireAndRefund",                     // 전체환불신청 및 탈퇴

  MAIN : '/main'                                           // 메인화면	O	POST	/member/main
}

export const OrderApi = {

  ORDER_CART : '/order/cart',                                     // 주문	주문확인하기(장바구니)		  POST	/order/cart	주문확인화면으로 전환
  ORDER_DIRECT : '/order/direct',                                 // 주문	주문확인하기(바로주문)		  POST	/order/direct	주문확인화면으로 전환
  ORDER_PAY : '/order/pay',                                       // 주문	결제하기		           POST	/order/pay
  ORDER_PAY_COMPLETE : '/order/pay/complete',                     // 주문	결제완료		           POST	/order/pay/complete	주문결제완료 처리
  ORDER_CANCEL : '/order/cancel',                                 // 주문	주문취소		           POST	/order/cancel
  GET_ORDER_HISTORY_LIST : '/order/list',                 // 주문	주문이력목록		        GET	/order/list
  GET_ORDER_HISTORY_DETAIL : '/order/detail',             // 주문	주문이력상세		        GET	/order/detail
  ORDER_CHECK_STORE : '/order/check/store',                       // 주문가능매장확인             GET /order/check/store
  GET_RECEIPT : '/receipt/get',                                   // 영수증 조회                GET /receipt/get
  EXTERNAL_GIFTS_API : '/external-gifts'
}

export const DeliveryApi = {
  DELIVERY_CART : '/delivery/cart',                               // 딜리버리	딜리버리확인하기(장바구니)		POST	/delivery/cart	주문확인화면으로 전환
  DELIVERY_DIRECT : '/delivery/direct',                           // 딜리버리	딜리버리확인하기(바로주문)		POST	/delivery/direct	주문확인화면으로 전환
  DELIVERY_PAY : '/delivery/pay',                                 // 딜리버리	딜리버리결제하기		POST	/delivery/pay
  DELIVERY_PAY_COMPLETE : '/delivery/pay/complete',                   // 딜리버리	딜리버리결제완료		POST	/delivery/pay/complete
  DELIVERY_CANCEL : '/delivery/cancel',                           // 딜리버리	딜리버리취소		POST	/delivery/cancel
  GET_DELIVERY_HISTORY_LIST : '/delivery/history/list',           // 딜리버리	딜리버리이력목록		GET	/delivery/history/list
  GET_DELIVERY_HISTORY_DETAIL : '/delivery/history/detail',       // 딜리버리	딜리버리이력상세		GET	/delivery/history/detail

  GET_DELIVERY_ADDRESSBOOK_LIST : '/delivery/addressbook/list',   // 딜리버리	주소록조회		GET	/delivery/addressbook/list
  ADD_DELIVERY_ADDRESSBOOK  : '/delivery/addressbook/add',        // 딜리버리	주소록저장		POST	/delivery/addressbook/add
  UPDATE_DELIVERY_ADDRESSBOOK : '/delivery/addressbook/update',   // 딜리버리	주소록수정		POST	/delivery/addressbook/update
  DELETE_DELIVERY_ADDRESSBOOK : '/delivery/addressbook/delete',   // 딜리버리	주소록삭제		POST	/delivery/addressbook/delete
  GET_DELIVERY_ADDRESS_RECENT : '/delivery/address/recent'        // 최근 주소 목록       GET /delivery/address/recent
}

export const StoreApi = {

  GET_STORE_LIST : '/store/list',                                 // 매장	매장목록		    GET	/store/list
  GET_STORE_DETAIL : '/store/get',                              // 매장	매장상세		    GET	/store/detal
  GET_STORE_FAVORITE_LIST : '/store/my/list',               // 매장	나의매장목록		POST	/store/my/list
  ADD_FAVORITE_STORE  : '/store/my/add',                    // 매장	나의매장등록		POST	/store/my/add
  DELETE_FAVORITE_STORE  : '/store/my/delete'               // 매장	나의매장삭제		POST	/store/my/delete
}

export const CartApi = {
  ADD_CART : '/cart/add'                                          // 장바구니담기		POST	/cart/add
  ,GET_CART_LIST : '/cart/list'                                   // 장바구니조회		GET	/cart/list
  ,DELETE_CART_ITEM  : '/cart/delete'                             // 장바구니삭제		POST	/cart/delete
  ,DELETE_SELECTED_CART_ITEMS  : '/cart/list/delete'                   // 장바구니 선택삭제		POST	/cart/delete
  ,GET_CART_COUNT : '/cart/count'                                     // 장바구니 개수  GET /cart/count(ORD - 맴버쉽오더용,   DLV - 딜리버리,  TBL -  테이블오더  EGT - E-GIFT)
}

export const MenuItemApi = {
  GET_ITEM_CATEGORY_LIST : '/item/category/list'                  // 상품카테고리목록조회		GET	/item/category/list
  ,GET_ITEM_LIST : '/item/list'                                   // 상품목록조회		      GET	/item/list
  ,GET_ITEM_INFO : '/item/info'                                   // 상품상세		GET	/item/info
  ,GET_FAVORITE_ITEM_LIST : '/item/favorite/list'                 // 나의메뉴목록		GET	/item/favorite/list
  ,ADD_FAVORITE_ITEM  : '/item/favorite/add'                      // 나의메뉴추가		POST	/item/favorite/add
  ,ADD_FAVORITE_ORDER_ITEM  : '/item/favorite/order/add'          // 나의메뉴추가		POST	/item/favorite/add
  ,DELETE_FAVORITE_ITEM : '/item/favorite/delete'                 // 나의메뉴삭제		POST	/item/favorite/delete

  ,GET_RECENT_MENU_LIST : '/order/menu/recent'                    //최근 이용 메뉴 /order/menu/recent
  ,GET_RECOMMEND_MENU_LIST : '/order/menu/recommend'              //추천 이용 메뉴 /order/menu/recommend

  ,GET_QUICK_ORDER_LIST : '/item/quick/list'                      //퀵오더 조회 : /item/quick/list?storeCode={storeCode}
  ,ADD_QUICK_ORDER_HISTORY : '/item/quick/order/add'              //퀵오더 추가 : 주문 내역에서
  ,ADD_QUICK_ORDER_MENU : '/item/quick/menu/add'                  //퀵오더 추가 : 메뉴에서
  ,DELETE_QUICK_ORDER : '/item/quick/delete'                      //퀵오더 삭제 :
}

export const GiftApi = {
  GET_GIFT_MAIN : '/gift/main'                                    // 기프트샵메인	O	GET	/gift/main
  ,GET_GIFT_EGIFT_ITEM_CATEGORY : '/gift/egift/item/category'     // E-Gift카테고리	O	GET	/gift/egift/item/category
  ,GET_GIFT_EGIFT_ITEM_LIST : '/gift/egift/item/list'             // E-Gift카테고리별 목록	O	GET	/gift/egift/item/list?category={categoryId}
  ,GET_GIFT_EGIFT_ITEM : '/gift/egift/item/get'                   // E-Gift상품상세	O	GET	/gift/egift/item/get?productCode={productCode}
  ,GET_GIFT_CARD_ITEM_CATEGORY : '/gift/card/product/category'       // 카드카테고리	O	GET	/gift/card/item/category
  ,GET_GIFT_CARD_ITEM_LIST  : '/gift/card/product/list'              // 카드카테고리별목록	O	GET	/gift/card/item/list?category={categoryId}
  ,POST_GIFT_EGIFT_CART_ORDER : '/gift/egift/cart/order'          // 선물주문요청(장바구니)	O	POST	/gift/egift/cart/order
  ,POST_GIFT_EGIFT_BUY_ORDER  : '/gift/egift/buy/order'           // 선물주문요청(바로선물-EGIFT)	O	POST	/gift/egift/buy/order
  ,POST_GIFT_CARD_BUY_ORDER : '/gift/card/buy/order'              // 선물주문요청(바로선물-CARD)	O	POST	/gift/card/buy/order
  ,POST_GIFT_PAY_COMPLETE : '/gift/pay/complete'                  // 선물주문결제완료	O	POST	/gift/pay/complete
  ,POST_GIFT_BUY_CANCEL : '/gift/buy/cancel'                      // 카드구매취소	O	POST	/gift/buy/cancel
  ,POST_GIFT_EXTEND : '/gift/egift/extend'                        // E-Gift 기한연장
  // ,GET_GIFT_EGIFT_ITEM_LIST:  '/gift/egift/list'                  // 선물목록	O	GET	/gift/egift/list
  // 선물목록	O	GET	/gift/egift/list

  ,REGIST_GIFT : '/gift/regist'                                   // 선물등록	O	POST	/gift/regist
  ,GET_GIFT_LIST : '/gift/list'                                   // 선물 목록 GET /gift/list?searchType={searchType}&size={size}&page={page}
  ,GET_GIFT_INFO : '/gift/info'														        // 선물 상세 GET /gift/info?presentNo={presentNo}
  ,CANCEL_BUY_GIFT  : '/gift/buy/cancel'													// 선물 취소 POST /gift/buy/cancel
  ,RESEND_GIFT : '/gift/resend'                                   // 선물 재전송 POST /gift/resend
  ,CANCEL_GIFT : '/gift/buy/cancel'                               // 선물 취소 POST /gift/buy/cancel
  ,GIFT_REFUND : '/gift/egift/refund'                             // 선물 환불 POST /gift/egift/refund
}

export const EventNewsApi = {
  GET_EVENT_LIST  : '/board/event/list'                                 // 이벤트	조회		GET	/event/list
  ,GET_EVENT : '/board/event/get'                                       // 이벤트	상세		GET	/event/get?eventId={eventId}
  ,GET_BANNER_LIST  : '/banner/list'                             // 배너	조회		GET	/bannner/list
  ,GET_NEWS_LIST  : '/board/news/list'                                  // 뉴스	조회		GET	/news/list
  ,GET_NEWS : '/board/news/get'                                         // 뉴스	상세		GET	/news/get?newsId={newsId}
  ,GET_PUSH_LIST  : '/push/list'                                  // 알림	목록	O	GET	/push/list
  ,GET_EVENT_FREQUENCY  : '/event/frequency/get'                        // 프리퀀시	상세		GET	/event/frequency/get?freNo={freNo}
}

export const CouponApi = {

  GET_COUPON_LIST : '/coupon/list',                                 // 쿠폰목록	O	/coupon/list?searchType={searchType}&size={size}&page={page}
  GET_COUPON_DETAIL : '/coupon/get',                                // 쿠폰상세	O	GET /coupon/get?couponNo={couponNo}
  REGIST_COUPON : '/coupon/regist',                                  // 쿠폰등록	O	POST	/coupon/regist
  GIFT_COUPON : '/gift/coupon'                                      // 쿠폰선물하기 POST /gift/coupon
}
export const StampApi = {
  GET_STAMP_LIST : '/member/stamp/list',                            //스탬프조회	O	POST	/stamp/list
  GET_STAMP_HISTORY : '/member/stamp/history',                             //스탬프적립이력	O	POST	/stamp/history
  EXCHANGE_STAMP : '/member/stamp/exchange',                         // 스팬프 쿠폰변화  POST /member/stamp/exchange
  GET_FREQUENCY_INFO : '/member/frequency/view',                         // 프리퀀시   GET /member/frequency/view
  EXCHANGE_FREQUENCY : '/member/frequency/exchange',                         // 프리퀀시 쿠폰변화  POST /member/frequency/exchange
}
export const CardApi = {
  GET_CARD_LIST : '/card/list',                                      // 카드목록	O	GET	/card/list
  GET_CARD_INFO : '/card/get/',                                      // 카드조회	O	GET	/card/get/{cardNo}
  GET_CARD_HISTORY : '/card/history',                                // 카드이용내역목록	O	GET	/card/history?cardNo={cardNo}
  REGIST_CARD : '/card/regist',                                     // 카드등록	O	POST	/card/regist
  CARD_CHARGE_ORDER:'/card/charge/order',                           // 카드충전주문요청	O	POST	/card/charge/order
  CARD_CHARGE_COMPLETE : '/card/charge/complete',                   // 카드충전결제완료	O	POST	/card/charge/complete
  CARD_CHARGE_CANCEL : '/card/charge/cancel',               // 카드충전취소요청	O	POST	/card/charge/cancel/request
  CARD_SET_AUTO_CHARGE : '/card/autocharge/set',                    // 카드자동충전설정	O	POST	/card/autocharge/set
  CARD_SET_AUTO_CHARGE_CANCEL : '/card/autocharge/set/cancel',      // 카드자동충전해지	O	POST	/card/autocharge/set/cancel
  CARD_MOVE_BALANCE : '/card/balance/move',                         // 카드잔액이전	O	POST	/card/balance/move
  CARD_DELETE : '/card/delete',                                     // 카드삭제	O	POST	/card/delete
  CARD_LOST : '/card/lost',                                         // 분실신고	O	POST	/card/lost
}

export const SupportApi = {
  INQUERY: "/board/support/inquery", // 문의하기
  GET_FAQ: "/board/faq/list", // FAQ

}

export const SurveyApi = {
  GET_SURVEY_LIST : '/surveys',                            //스탬프조회	O	POST	/stamp/list
}




// WEBPACK FOOTER //
// ./src/api/Api.js